import React, { FC } from 'react'
import GoogleMapReact from 'google-map-react'
import { useSelector } from 'react-redux'
import { GOOGLE_MAP_API_KEY } from 'src/common/razzle-platform-map/configs'
import MarkerWithIcon from 'src/common/razzle-platform-map/components/LocationMap/components/MarkerWithIcon'


export interface LocationMapProps {
    id?: string
    className?: string
    latitude: number
    longitude: number
    zoom?: number
}


export const LocationMap: FC<LocationMapProps> = ({ latitude, longitude, zoom=8 }) => {
    // @ts-ignore
    const locale = useSelector((state) => state.translationModel.locale)
    if (latitude && longitude) {
        return (
            <GoogleMapReact
                bootstrapURLKeys={{
                    key: `${GOOGLE_MAP_API_KEY}&language=${locale}`,
                    language: locale
                }}
                defaultCenter={{
                    lat: latitude,
                    lng: longitude,
                }}
                defaultZoom={zoom}
            >
                <MarkerWithIcon isLarge lat={latitude} lng={longitude} />
            </GoogleMapReact>
        )
    }
    return null
}
